
import { getAnalytics, logEvent } from "firebase/analytics";
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Title, Meta } from '@angular/platform-browser';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ContactModalComponent } from '../contact/contact-modal/contact-modal.component';
import { IServiceList, ServicesPageService } from '../services-page/services-page.service';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit {
  public contentList = [
    {
      title: "Online Presence",
      description: "Using our industry leading 6-point system, we determine how we can improve your website's authority and give your business a greater online presence."
    },
    {
      title: "Marketing Strategy",
      description: "No single strategy works for every company, we take our time to determine what your target audience is and what works for them."
    },
    {
      title: "Promote Local Sales",
      description: "For many local businesses, staying local is important to keep things manageable, we know what works for Colorado residents and how to target them"
    }
  ]

  public reviews = [
    {
      id: 0,
      review: 'I wanted to start a photobooth business on the side but did not know where to start. Avanta Marketing help me start it. They took care of designing the logo, creating the website, emails, business cards, and marketting events.  Some of the really cool parts of the website they built in are bilingual support, automated contact form, and a way for customer to book photobooth events directly on the website. They also worked on make it super efficient, bringing down my recurring hosting costs to near zero, which is perfect for me.',
      avatarSrc: 'assets/img/avatar_1.png',
      reviewer: 'Diana Villalba',
      title: 'Epic Photobooth Fun',
    },
    {
      id: 1,
      review: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsam est modi amet error earum aperiam, fuga labore facere rem ab nemo possimus cum excepturi expedita. Culpa rerum, quaerat qui non.',
      avatarSrc: 'assets/img/avatar_2.png',
      reviewer: 'Zack Stampfl',
      title: 'The AZ Way Handymen',
    },
    {
      id: 2,
      review: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsam est modi amet error earum aperiam, fuga labore facere rem ab nemo possimus cum excepturi expedita. Culpa rerum, quaerat qui non.',
      avatarSrc: 'assets/img/avatar_3.png',
      reviewer: 'Matthew Horine',
      title: 'CEO, Matt',
    }
  ]
  
  public customOptions: OwlOptions = {
    loop: true,
    center: true,
    margin: 40,
    nav: false,
    dots: false,
    smartSpeed: 1000,
    autoplay: true,
    autoplayTimeout: 4000,
    animateOut: 'slideOutDown',
    animateIn: 'flipInX',
    responsive: {
        0: {
            items: 1
        },
        576: {
            items: 2
        },
        768: {
            items: 2
        },
        992: {
            items: 3
        }
    }
  }
  public serviceList: IServiceList[];

  constructor(private title: Title, 
    private analytics: AngularFireAnalytics,
    private meta: Meta, 
    private servicesService: ServicesPageService,
    private dialog: MatDialog) { 
      console.log('logging analytic')
      analytics.logEvent('page_view')
    }

  ngOnInit(): void {
    this.serviceList = this.servicesService.serviceList.slice(0,3)
    this.title.setTitle('Avanta Marketing');
    this.analytics.logEvent('view_process')
    this.meta.addTags([
      { name: 'twitter:card', content: 'summary' },
      { name: 'og:url', content: '/' },
      { name: 'og:title', content: 'Landing Page' },
      { name: 'og:description', content: "Denver's Premier Digital Agency" },
      { name: 'og:image', content: 'https://avantamarketing.com/assets/img/logo.png' },
    ])
  }

  
  openContactModal() {
    this.dialog.open(ContactModalComponent, {  
      data: {},
      width: 'fit-content',
      height: 'fit-content',
      panelClass: 'contact-modal'
    });
  }

  analyticLog(type) {
  }
}
